/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantReadDto } from './ParticipantReadDto';
import {
    ParticipantReadDtoFromJSON,
    ParticipantReadDtoFromJSONTyped,
    ParticipantReadDtoToJSON,
    ParticipantReadDtoToJSONTyped,
} from './ParticipantReadDto';

/**
 * 
 * @export
 * @interface ParticipantRoleReadDto
 */
export interface ParticipantRoleReadDto {
    /**
     * 
     * @type {number}
     * @memberof ParticipantRoleReadDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ParticipantRoleReadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantRoleReadDto
     */
    description: string;
    /**
     * 
     * @type {ParticipantReadDto}
     * @memberof ParticipantRoleReadDto
     */
    participant: ParticipantReadDto;
}

/**
 * Check if a given object implements the ParticipantRoleReadDto interface.
 */
export function instanceOfParticipantRoleReadDto(value: object): value is ParticipantRoleReadDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('participant' in value) || value['participant'] === undefined) return false;
    return true;
}

export function ParticipantRoleReadDtoFromJSON(json: any): ParticipantRoleReadDto {
    return ParticipantRoleReadDtoFromJSONTyped(json, false);
}

export function ParticipantRoleReadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantRoleReadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'participant': ParticipantReadDtoFromJSON(json['participant']),
    };
}

export function ParticipantRoleReadDtoToJSON(json: any): ParticipantRoleReadDto {
    return ParticipantRoleReadDtoToJSONTyped(json, false);
}

export function ParticipantRoleReadDtoToJSONTyped(value?: ParticipantRoleReadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'participant': ParticipantReadDtoToJSON(value['participant']),
    };
}

